import { DECISION_KINDS as e, useDecisionsQuery as t } from "@frontends/data-access-spg-decisions";
import { useAllInstancesQuery as n } from "@frontends/data-access-spg-instances";
import { useAllRetentionRulesQuery as r } from "@frontends/data-access-spg-retention-rules";
import { useDataTable as i } from "@frontends/data-table";
import { DsBadge as a, DsButton as o, DsDialog as s, DsLink as c } from "@frontends/ds";
import { formatDateTime as l, personDetail as u, personName as d } from "@frontends/util-spg-format";
import { useState as f } from "react";
import { useTranslation as p } from "react-i18next";
import { formatDuration as m, intervalToDuration as h } from "date-fns";
import { PropertyList as g } from "@frontends/ui-spg-layout";
import { Fragment as _, jsx as v, jsxs as y } from "react/jsx-runtime";
//#region src/lib/constants.ts
var b = "feature-spg-decisions", x = {
	check_started: "neutral",
	rejection: "danger",
	join_confirmed: "success",
	grant: "success",
	return: "info",
	risk_cleared: "success",
	warning: "warning",
	removal: "danger",
	block: "danger",
	unblock: "info",
	evaluated_no_change: "neutral",
	exempted: "info",
	exemption_lifted: "info"
};
function S(e) {
	return x[e];
}
var C = {
	"": "info",
	queued: "info",
	applied: "success",
	not_applied: "danger",
	skipped: "neutral"
};
function w(e) {
	return C[e];
}
function T(e, t) {
	return t(`reasons.${e}`, { defaultValue: e });
}
function E(e) {
	return e.person ? d(e.person) : e.participationId;
}
function D(e, t) {
	return e.person ? u(e.person, t(`platforms.${e.person.platform}`)) : "";
}
var O = {
	seconds: 1,
	minutes: 60,
	days: 86400
};
function k(e, t) {
	let n = /_(seconds|minutes|days)$/.exec(e)?.[1];
	return n && typeof t == "number" ? m(h({
		start: 0,
		end: t * O[n] * 1e3
	})) || m({ seconds: 0 }, { zero: !0 }) : e.endsWith("_at") && typeof t == "string" && !Number.isNaN(Date.parse(t)) ? l(t) : Array.isArray(t) ? t.join(", ") : typeof t == "object" && t ? JSON.stringify(t) : String(t);
}
function A(e, t) {
	return Object.entries(e).map(([e, n]) => [t(`evidence.${e}`, { defaultValue: e.replaceAll("_", " ") }), k(e, n)]);
}
//#endregion
//#region src/lib/components/DecisionDialog.tsx
function j({ rows: e }) {
	return /* @__PURE__ */ v(g, { items: e.map(([e, t]) => ({
		label: e,
		value: t
	})) });
}
function M({ decision: e, getRuleHref: t, instanceName: n, onClose: r, ruleName: i }) {
	let { t: u } = p(b), [d, m] = f(!1), h = A(e.evidence, u);
	return /* @__PURE__ */ v(s, {
		title: T(e.reasonCode, u),
		size: "lg",
		isOpen: !0,
		onOpenChange: (e) => !e && r(),
		children: /* @__PURE__ */ y("div", {
			className: "flex flex-col gap-6",
			children: [
				/* @__PURE__ */ y("div", {
					className: "flex flex-wrap items-center gap-2",
					children: [/* @__PURE__ */ v(a, {
						variant: S(e.type),
						children: u(`types.${e.type}`)
					}), /* @__PURE__ */ v(a, {
						variant: w(e.applicationStatus),
						children: u(`application.${e.applicationStatus || "pending"}`)
					})]
				}),
				/* @__PURE__ */ v(j, { rows: [
					[u("fields.person"), `${E(e)} — ${D(e, u)}`],
					[u("fields.instance"), n],
					[u("fields.origin"), e.retentionRuleId ? /* @__PURE__ */ v(c, {
						href: t(e.retentionRuleId),
						children: i ?? u("origin.rule")
					}, "rule") : u(e.entryFlowId ? "origin.entryFlow" : `initiators.${e.initiatorType}`, { defaultValue: e.initiatorType })],
					...e.initiatorId ? [[u("fields.initiator"), e.initiatorId]] : [],
					[u("fields.statusMove"), `${e.previousStatus || "—"} → ${e.newStatus || "—"}`],
					[u("fields.decidedAt"), l(e.createdAt)],
					[u("fields.appliedAt"), l(e.appliedAt)],
					...e.applicationReason ? [[u("fields.applicationReason"), e.applicationReason]] : []
				] }),
				/* @__PURE__ */ y("section", {
					className: "flex flex-col gap-3",
					children: [
						/* @__PURE__ */ y("div", {
							className: "flex items-center justify-between gap-3",
							children: [/* @__PURE__ */ v("h3", {
								className: "font-medium text-textPrimary",
								children: u("fields.evidence")
							}), h.length > 0 && /* @__PURE__ */ v(o, {
								variant: "secondary",
								size: "sm",
								onPress: () => m(!d),
								children: u(d ? "evidenceView.readable" : "evidenceView.raw")
							})]
						}),
						h.length === 0 && /* @__PURE__ */ v("p", {
							className: "text-base text-textSecondary",
							children: u("evidenceView.none")
						}),
						h.length > 0 && !d && /* @__PURE__ */ v(j, { rows: h }),
						h.length > 0 && d && /* @__PURE__ */ v("pre", {
							className: "overflow-auto rounded-lg bg-backgroundSecondary p-3 font-mono text-sm text-textPrimary",
							children: JSON.stringify(e.evidence, null, 2)
						})
					]
				})
			]
		})
	});
}
//#endregion
//#region src/lib/components/DecisionsTable.tsx
var N = "all";
function P({ scope: o, getRuleHref: s }) {
	let { t: c } = p(b), [u, d] = f(null), m = n().data ?? [], h = (r().data ?? []).filter((e) => !o.instanceId || e.instanceId === o.instanceId), g = new Map(m.map((e) => [e.id, e.name])), x = new Map(h.map((e) => [e.id, e.name])), C = !o.ruleId && !o.runId, O = (e) => e.retentionRuleId ? x.get(e.retentionRuleId) ?? c("origin.rule") : c(e.entryFlowId ? "origin.entryFlow" : `initiators.${e.initiatorType}`, { defaultValue: e.initiatorType }), k = [
		{
			id: "created_at",
			label: c("columns.time"),
			isSortable: !0,
			width: 170,
			cell: (e) => l(e.createdAt)
		},
		...o.participationId ? [] : [{
			id: "person",
			label: c("columns.person"),
			width: 220,
			cell: (e) => /* @__PURE__ */ y("div", {
				className: "flex min-w-0 flex-col",
				children: [/* @__PURE__ */ v("span", {
					className: "truncate",
					children: E(e)
				}), /* @__PURE__ */ v("span", {
					className: "truncate text-sm text-textSecondary",
					children: D(e, c)
				})]
			})
		}],
		...o.instanceId ? [] : [{
			id: "instance",
			label: c("columns.instance"),
			width: 160,
			cell: (e) => g.get(e.instanceId) ?? c("unknown")
		}],
		{
			id: "event",
			label: c("columns.event"),
			isRowHeader: !0,
			cell: (e) => /* @__PURE__ */ y("div", {
				className: "flex min-w-0 flex-col gap-1",
				children: [/* @__PURE__ */ y("span", {
					className: "flex items-center gap-2",
					children: [/* @__PURE__ */ v(a, {
						size: "sm",
						variant: S(e.type),
						children: c(`types.${e.type}`)
					}), /* @__PURE__ */ v("span", {
						className: "text-sm text-textSecondary",
						children: O(e)
					})]
				}), /* @__PURE__ */ v("span", {
					className: "truncate",
					children: T(e.reasonCode, c)
				})]
			})
		},
		{
			id: "application",
			label: c("columns.application"),
			width: 140,
			skeleton: "pill",
			cell: (e) => /* @__PURE__ */ v(a, {
				size: "sm",
				variant: w(e.applicationStatus),
				children: c(`application.${e.applicationStatus || "pending"}`)
			})
		}
	], A = {
		type: "chips",
		label: c("filters.kind"),
		defaultValue: N,
		options: [{
			value: N,
			label: c("filters.allKinds")
		}, ...Object.keys(e).map((e) => ({
			value: e,
			label: c(`kinds.${e}`)
		}))]
	}, j = {
		type: "select",
		label: c("filters.rule"),
		defaultValue: N,
		options: [{
			value: N,
			label: c("filters.allOrigins")
		}, ...h.map((e) => ({
			value: e.id,
			label: e.name
		}))]
	}, P = {
		type: "checkbox",
		label: c("filters.failedOnly"),
		defaultValue: !1
	}, F = {
		type: "dateRange",
		label: c("filters.period"),
		defaultValue: null
	}, I = i({
		"aria-label": c("table.label"),
		columns: k,
		defaultSort: {
			by: "created_at",
			order: "desc"
		},
		getRowKey: (e) => e.id,
		onRowAction: d,
		pageSize: 25,
		filters: C ? {
			kind: A,
			rule: j,
			failedOnly: P,
			period: F
		} : {
			kind: A,
			failedOnly: P,
			period: F
		}
	}), L = I.filters, R = t(I.requestParams, {
		...o,
		kind: L.kind === N ? void 0 : L.kind,
		ruleId: o.ruleId ?? (L.rule && L.rule !== N ? L.rule : void 0),
		failedOnly: L.failedOnly,
		from: L.period ? `${L.period.start.toString()}T00:00:00Z` : void 0,
		to: L.period ? `${L.period.end.add({ days: 1 }).toString()}T00:00:00Z` : void 0
	});
	return /* @__PURE__ */ y(_, { children: [/* @__PURE__ */ y(I.Frame, { children: [/* @__PURE__ */ v(I.Toolbar, {}), /* @__PURE__ */ v(I.Table, {
		query: R,
		emptyState: {
			icon: "history",
			title: c("empty.title")
		}
	})] }), u && /* @__PURE__ */ v(M, {
		decision: u,
		instanceName: g.get(u.instanceId) ?? c("unknown"),
		ruleName: u.retentionRuleId ? x.get(u.retentionRuleId) : void 0,
		getRuleHref: s,
		onClose: () => d(null)
	})] });
}
//#endregion
export { P as DecisionsTable, b as FEATURE_SPG_DECISIONS_NAMESPACE };
